// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"4176896a","105":"1a62b9f1","240":"08ad1256","252":"a07365cd","298":"83f7c0a6","354":"4c3642a4","362":"3645b4a2","453":"8cd40781","526":"27028908","708":"18802315","787":"c8fd0327","791":"44aacbc4","794":"a79e260c","828":"656cf7c2","961":"149ee6f5"}[chunkId] + ".chunk.js";
};